import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

export const REGULATORY_ADD_ONS = [
  { key: "aiWizard", label: "AI Wizard" },
  { key: "fatca", label: "FATCA" },
  { key: "internalAmlPolicy", label: "Internal AML Policy" },
];

export function regulatoryAddOns(settings) {
  return Object.fromEntries(REGULATORY_ADD_ONS.map(({ key }) => [key, settings?.[key] === true]));
}

export default function useRegulatoryAddOns(orgId) {
  const [snapshot, setSnapshot] = useState(null);
  useEffect(() => {
    if (!orgId) return undefined;
    let active = true;
    const unsubscribe = onSnapshot(doc(db, "orgs", orgId), (org) => {
      if (active) setSnapshot({ orgId, settings: org.data()?.settings?.regulatoryAddOns });
    }, () => {
      if (active) setSnapshot({ orgId, settings: null });
    });
    return () => { active = false; unsubscribe(); };
  }, [orgId]);
  return regulatoryAddOns(orgId && snapshot?.orgId === orgId ? snapshot.settings : null);
}
